import { render, staticRenderFns } from "./Votefile.vue?vue&type=template&id=8308bc76&scoped=true"
import script from "./Votefile.vue?vue&type=script&lang=js"
export * from "./Votefile.vue?vue&type=script&lang=js"
import style0 from "./Votefile.vue?vue&type=style&index=0&id=8308bc76&prod&scoped=true&lang=css"
import style1 from "./Votefile.vue?vue&type=style&index=1&id=8308bc76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8308bc76",
  null
  
)

export default component.exports